import React from "react";
import { Save } from "lucide-react";
import ProjectForm from "./components/ProjectForm";

const EditProject = () => {
  return <ProjectForm isEdit={true} submitIcon={Save} />;
};

export default EditProject;
